//加载报警类型否显示加载中...
export const FAILURETYPE_TYPES_LIST_LOAD='failure/type/list/FETCH_FAILURETYPE_TYPES_LOAD';
//异步加载报警类型信息
export const FETCH_FAILURETYPE_TYPES_LIST='failure/type/list/FETCH_FAILURETYPE_TYPES';
//处理报警类型信息
export const FAILURETYPE_TYPES_LIST='failure/type/list/FAILURE_TYPES';
//选中的报警类型信息
export const FAILURETYPE_TYPES_ID='failure/type/list/FAILURE_TYPE_ID';